import { Button } from '@profitowi/component-library';
import { Cell, Column } from 'react-table';

import { DICTIONARY_TYPES } from '../../../../constants/dictionaryTypes';
import useDictionaryContext from '../../../../hooks/useDictionaryContext';
import { CommissionSchemaFile } from '../../../../types/commission';

export const columns = (deleteFile: (fileId: number) => void): Column<CommissionSchemaFile>[] => [
  {
    Header: 'Data importu',
    accessor: 'createdAt',
  },
  {
    Header: 'Nazwa pliku',
    accessor: 'fileName',
  },
  {
    Header: 'Suma premii',
    accessor: 'bonusSum',
  },
  {
    Header: 'Liczba wierszy',
    accessor: 'numberOfRows',
  },
  {
    Header: 'Typ pliku',
    accessor: 'fileType',
    Cell: ({
      row: {
        original: { fileType },
      },
    }: Cell<CommissionSchemaFile>) => {
      const { translate } = useDictionaryContext();

      return fileType ? translate(DICTIONARY_TYPES.FILE_TYPE, fileType) : '';
    },
  },
  {
    id: 'operations',
    disableSortBy: true,
    Cell: ({
      row: {
        original: { fileId, deletable },
      },
    }: Cell<CommissionSchemaFile>) => {
      if (deletable)
        return (
          <div className="flex space-x-2">
            <Button onPress={() => deleteFile(fileId)} size="sm" variant="light">
              Usuń
            </Button>
          </div>
        );

      return <></>;
    },
  },
];
